// frontend/src/services/assinaturaService.js
import api from './apiService';

export const getPlanos = async () => {
  const response = await api.get('assinaturas/planos/');
  return response.data;
};

/**
 * Inicia checkout. Opcionalmente envia dados_cliente para cobrança (Asaas).
 * @param {number} planoId - ID do plano
 * @param {object} [dadosCliente] - nome_completo, cpf, telefone, cep, endereco, numero, complemento, bairro, cidade, estado
 * @param {'PIX'|'CREDIT_CARD'} [formaPagamento] - forma da recorrência (boleto não é aceito)
 */
export const criarCheckout = async (planoId, dadosCliente = null, formaPagamento = 'PIX') => {
  const body = { plano_id: planoId, forma_pagamento: formaPagamento };
  if (dadosCliente && typeof dadosCliente === 'object') {
    body.dados_cliente = dadosCliente;
  }
  const response = await api.post('assinaturas/checkout/', body);
  return response.data;
};

export const getMinhaAssinatura = async () => {
  const response = await api.get('assinaturas/minha-assinatura/');
  return response.data;
};

export const previewAlterarPlano = async (planoId) => {
  const response = await api.get('assinaturas/minha-assinatura/plano/preview/', {
    params: { plano_id: planoId },
  });
  return response.data;
};

export const alterarPlano = async (planoId) => {
  const response = await api.put('assinaturas/minha-assinatura/plano/', { plano_id: planoId });
  return response.data;
};

export const trocarCartao = async () => {
  const response = await api.post('assinaturas/minha-assinatura/trocar-cartao/');
  return response.data;
};

export const getFormaPagamento = async () => {
  const response = await api.get('assinaturas/minha-assinatura/forma-pagamento/');
  return response.data;
};

export const alterarFormaPagamento = async (formaPagamento) => {
  const response = await api.put('assinaturas/minha-assinatura/forma-pagamento/', {
    forma_pagamento: formaPagamento,
  });
  return response.data;
};

/** Payload: { creditCard, creditCardHolderInfo, remoteIp? } */
export const tokenizarCartao = async (payload) => {
  const response = await api.post('assinaturas/minha-assinatura/tokenizar-cartao/', payload);
  return response.data;
};

/** Payload: { creditCardToken, remoteIp? } */
export const atualizarCartao = async (payload) => {
  const response = await api.post('assinaturas/minha-assinatura/atualizar-cartao/', payload);
  return response.data;
};

export const cancelarAssinatura = async () => {
  const response = await api.post('assinaturas/minha-assinatura/cancelar/');
  return response.data;
};

/** Reativa assinatura desativada (sem cobrança até a data de renovação). planoId opcional. */
export const reativarAssinatura = async (planoId = null) => {
  const body = planoId != null ? { plano_id: planoId } : {};
  const response = await api.post('assinaturas/minha-assinatura/reativar/', body);
  return response.data;
};

export const sincronizarStatusAssinatura = async () => {
  const response = await api.post('assinaturas/minha-assinatura/sync-status/');
  return response.data;
};

export const cancelarAlteracaoPendente = async () => {
  const response = await api.post('assinaturas/minha-assinatura/cancelar-alteracao/');
  return response.data;
};

export const getFaturas = async () => {
  const response = await api.get('assinaturas/minha-assinatura/faturas/');
  return response.data;
};
